module.exports = {
      id: "back-icon-usage",
      viewBox: "0 0 7.828 12.828",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#back-icon",
      toString: function () {
        return this.url;
      }
    }